jQuery(function($){
	$('.email-link').click(function(e){
		e.preventDefault();
		let disclaimerModal = $('#email-disclaimer');
		let emailAddress = $(this).data('email');
		disclaimerModal.find('.confirm-link').attr('href', 'mailto:' + emailAddress);
		disclaimerModal.modal('show');
	});
});
